if (!customElements.get("quickbuy-variant-radios")) {
  customElements.define(
    "quickbuy-variant-radios",
    class QuickBuyVariantRadios extends VariantSelects {
      constructor() {
        super();

        this.dataset.updateUrl = false;
        this.dataset.updateSwatch = false;
        this.dataset.updateVariantTitle = true;

        this.bindEvents();
      }

      onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
          this.setUnavailable();
        } else {
          this.updateURL();
          this.updateVariantInput();
          this.renderProductInfo();
          this.renderFeaturedReviews();
          this.updateShareUrl();
        }
      }

      bindEvents() {
        [...this.querySelectorAll(".js-show-more-variants")].forEach((el) =>
          el.addEventListener("click", this.toggleMoreVariants),
        );
      }

      updateMedia() {
        if (!this.currentVariant.featured_image) return;
        const activeMedia = this.closest(".product-card").querySelector(
          ".product-card__variant-image.active",
        );

        const newMedia = this.closest(".product-card").querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_image.id}"]`,
        );

        if (!newMedia) return;

        activeMedia.classList.remove("active");
        newMedia.classList.add("active");
      }

      updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          ).value;
        });
      }

      updateVariantInfo() {
        const variantTitle = this.querySelector(".js-quickbuy-variant-title");
        const metafield = variantTitle.getAttribute("metafield");
        if (metafield) {
          const variantNew = document.querySelector(
            `[data-product-form-id=${this.dataset.productFormId}`,
          );
          const newSpan = variantNew.querySelector(".js-quickbuy-new");
          if (
            metafield.includes(this.currentVariant.title.toLowerCase()) &&
            this.currentVariant.title !== "Chill"
          ) {
            newSpan.innerHTML = "&nbsp;*(NEW)";
          } else {
            newSpan.innerHTML = "";
          }
        }
        variantTitle.innerHTML = this.currentVariant.title;
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#${this.dataset.productFormId}, #product-form-installment`,
        );

        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');

          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });

        this.updateVariantInfo();
        this.updateMedia();
      }

      toggleMoreVariants({ target }) {
        target
          .closest(".options")
          ?.querySelector("fieldset")
          ?.classList.toggle("active");
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;

        const queryChar = this.dataset.url.includes("?") ? "&" : "?";

        let fetchUrl = `${this.dataset.url}${queryChar}variant=${requestedVariantId}&section_id=main-product`;
        if (fetchUrl.includes("-metafield")) {
          fetchUrl = fetchUrl.split("-metafield")[0];
        }
        fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => {
            // prevent unnecessary ui changes from abandoned selections
            if (this.currentVariant.id !== requestedVariantId) return;

            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const destination =
              this.closest(".product-card").querySelector(".price__container");
            const productForm = html.querySelector(
              "#" + this.dataset.productFormId,
            );
            const source = html.querySelector(".price__container");

            if (source && destination) destination.innerHTML = source.innerHTML;

            // const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
            const addButtonUpdated = html.querySelector(
              `[id^=ProductSubmitButton-`,
            );

            this.toggleAddButton(
              addButtonUpdated
                ? addButtonUpdated.hasAttribute("disabled")
                : true,
              window.variantStrings.soldOut,
            );

            const productBundle = this.closest(
              ".product-bundle-variant-picker",
            );
            if (productBundle) {
              const mediaDestination =
                document.querySelector("[id^=MediaGallery]");
              const mediaSource = html.querySelector("[id^=MediaGallery]");
              if (mediaSource && mediaDestination) {
                mediaDestination.innerHTML = mediaSource.innerHTML;
                mediaDestination.init();
              }
            }
          });
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(this.dataset.productFormId);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');

        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text + " — ";
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.variantStrings.addToCart + " — ";
        }

        if (!modifyClass) return;
      }
    },
  );
}
